import { FEEDBACK_CATEGORY } from './constants';
import {
  RequestFnParams,
  RequestBody,
  Settings,
  RequestFn,
  FeedbackProps,
} from './types';
import invariant from 'tiny-invariant';

/**
 * Хук, создающий функцию отправки с заданными параметрами
 */
export function useFeedbackRequest(settings: FeedbackProps): RequestFn {
  if (settings.request) return settings.request;
  return function requestFunction(params: RequestFnParams) {
    let {
      eno,
      serviceId,
      xCallerId,
      category = FEEDBACK_CATEGORY.CONVENIENCE_OF_APPLYING,
    } = settings;
    let { rate, comment } = params;

    invariant(typeof xCallerId === 'string', 'Передайте xCallerId');
    invariant(typeof serviceId === 'string', 'Передайте serviceId');

    let body: RequestBody = {
      rate: Number(rate),
      category: Number(category),
    };
    if (comment && comment.length > 0) {
      body.comment = comment;
    }
    if (eno) {
      body.eno = eno;
    }

    return fetch(`/api/cma-rating/v1/rating/${serviceId}`, {
      method: 'POST',
      headers: {
        'x-caller-id': xCallerId,
      },
      body: JSON.stringify(body),
    }).then((response) => response.json());
  };
}
